import styled from "styled-components";

export const DateFilterContainer = styled.div`
  position: sticky;
  top: 0;
  width: 100%;
  padding: 8px 20px;
  background: ${(props) => props.theme.colors.white};
  border-bottom: 1px solid ${(props) => props.theme.colors.mainBg};
  z-index: 100;
`;

export const DateFilterWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
`;

export const ArrowButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${(props) => props.theme.colors.mainBg};
  }

  svg {
    color: ${(props) => props.theme.colors.primary};
  }
`;

export const DateDisplay = styled.span`
  font-size: 1.6rem;
  font-weight: 600;
  color: ${(props) => props.theme.colors.primary};
  min-width: 100px;
  text-align: center;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 6px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${(props) => props.theme.colors.mainBg};
  }
`;
